import { COUPONS_LOADED, COUPONS_GET_SUCCESS } from '../actionTypes/CouponActionTypes';

const getCouponsLoaded = () => ({
    type: COUPONS_LOADED,
    payload: { pageName: 'coupon' },
});

const getCouponsOnSuccess = (coupons) => ({
    type: COUPONS_GET_SUCCESS,
    coupons,
});

export default {
    getCouponsLoaded,
    getCouponsOnSuccess,
};
